import Image from 'next/image';

import { Button, Text } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import { getPageURL, ROUTE_CONFIG } from '@/services/hostPortal.service';
import { PAYMENT_RECEIPT_STATUS } from '@/services/payment.service';

const getDetailsSpecificToPaymentResponseStatus = ({
  paymentReceiptStatus
}) => {
  let details;
  switch (paymentReceiptStatus) {
    case PAYMENT_RECEIPT_STATUS.PASS:
      details = {
        responseTitle: 'Payment Successful!',
        statusIcon: 'payment-success.svg',
        statusMessage: 'Your payment is successful.'
      };
      break;
    case PAYMENT_RECEIPT_STATUS.FAIL:
    default:
      details = {
        responseTitle: 'Payment Failed!',
        statusIcon: 'payment-failed.svg',
        statusMessage: 'Oh no! Something went wrong.'
      };
      break;
  }
  return details;
};

const BotTriageLeadPaymentResponse = ({
  botTriageLeadNumber,
  botTriageLeadPaymentId,
  paymentReceiptStatus,
  router
}) => {
  const { responseTitle, statusIcon, statusMessage } =
    getDetailsSpecificToPaymentResponseStatus({ paymentReceiptStatus });

  return (
    <div className='min-h-screen flex items-center justify-center px-4'>
      <div className='flex flex-col gap-4 text-center w-full max-w-md py-10'>
        <Text
          {...{
            className: 'text-xl md:text-3xl font-medium text-nero',
            content: responseTitle
          }}
        />
        <div className='py-5'>
          <Image
            alt='Payment status'
            height={112}
            src={`${staticMediaStoreBaseURL}/icons/${statusIcon}`}
            width={112}
          />
        </div>
        <div className='text-sm md:text-base font-light mb-0'>
          <Text
            {...{
              content: statusMessage,
              HtmlTag: 'span'
            }}
          />
        </div>
        <div className='text-sm md:text-base font-light mb-0'>
          <Text
            {...{
              content: `Reference number: ${botTriageLeadNumber}`,
              HtmlTag: 'span'
            }}
          />
        </div>
        <div className='text-sm md:text-base font-light mb-0'>
          <Text
            {...{
              content: `BTL Payment Id: ${botTriageLeadPaymentId}`,
              HtmlTag: 'span'
            }}
          />
        </div>
        <div className='pt-6'>
          <Button
            {...{
              children: 'Close',
              className:
                'w-full px-6 py-2 border border-brand text-brand rounded-md',
              onClick: () =>
                router.push(
                  getPageURL({ pageName: ROUTE_CONFIG.HOME_PAGE.label })
                )
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BotTriageLeadPaymentResponse;
